import React, { useState } from 'react';
import TimeSelectField from '../../Surveys/TimeSelectField';

export default function TimeEditor({ value, column, onSave, onCancel }) {
  const [val, setVal] = useState(value || '');

  const handleChange = (e) => {
    setVal(e.target.value);
  };

  return (
    <>
      <TimeSelectField
        value={val}
        format={column.custom_format || '12h'}
        onChange={handleChange}
        style={{ minWidth: '160px' }}
      />
      <button className="cm-cell-edit-btn cm-cell-edit-btn--save" onClick={() => onSave(val)}>
        <i className="fas fa-check" />
      </button>
      <button className="cm-cell-edit-btn cm-cell-edit-btn--cancel" onClick={onCancel}>
        <i className="fas fa-times" />
      </button>
    </>
  );
}
